import { APP_VIEWS } from '../hooks/useAppView.js';

const PRIMARY_TAB_IDS = ['matchups', 'decide', 'draft'];

const AppNav = ({ activeView, onNavigate }) => {
  const navigate = (viewId) => {
    onNavigate(viewId);
  };

  return (
    <header className="app-nav">
      <div className="app-nav__inner">
        <div className="app-nav__brand">
          <span className="app-nav__logo" aria-hidden="true">
            FF
          </span>
          <span className="app-nav__title">Fantasy Focus</span>
        </div>

        <nav className="app-nav__tabs app-nav__tabs--primary-only" aria-label="Main">
          {PRIMARY_TAB_IDS.map((id) => {
            const item = APP_VIEWS[id];
            const isActive = activeView === item.id;
            return (
              <button
                key={item.id}
                type="button"
                className={`app-nav__tab ${isActive ? 'is-active' : ''}`}
                onClick={() => navigate(item.id)}
                aria-current={isActive ? 'page' : undefined}
              >
                {item.label}
              </button>
            );
          })}
        </nav>
      </div>
    </header>
  );
};

export default AppNav;
